import {
  COOKIE_CONSENT_DEFAULTS,
  type CookieConsent,
  type CookieConsentList,
} from "../constants/cookie-consent";

export function consentToList<
  TConsent extends Partial<CookieConsent> | null,
  TReturn = TConsent extends null | { necessary?: false }
    ? null
    : CookieConsentList,
>(consent: TConsent): TReturn {
  if (consent === null || !consent.necessary) return null as TReturn;

  const list: CookieConsentList = [];

  if (consent.isDisabled) return ["disabled"] as TReturn;

  for (const [key, value] of Object.entries(consent)) {
    if (value === true)
      list.push(key as keyof Omit<CookieConsent, "isDisabled">);
  }

  return list as TReturn;
}

export function parseConsent<
  TList extends CookieConsentList | string | null | undefined,
  TReturn = TList extends null | undefined ? null : CookieConsent,
>(value: CookieConsentList | string | null): TReturn {
  if (value === null || value === undefined) return null as TReturn;

  const values = typeof value === "string" ? value.split(",") : value;

  if (!Array.isArray(values)) throw new Error("Unable to parse consent");

  if (values.includes("disabled")) {
    return COOKIE_CONSENT_DEFAULTS as TReturn;
  }

  return {
    necessary: values.includes("necessary"),
    preferences: values.includes("preferences"),
    marketing: values.includes("marketing"),
    statistics: values.includes("statistics"),
  } as TReturn;
}
